import React, { useState } from 'react';

import { Flex, HStack, Image, Text, VStack } from '@chakra-ui/react';

import { isEmpty } from 'lodash';
import colors from '../../constants/colors';
import { ReactComponent as ProfileFillIcon } from '../../icons/profile.fill.svg';
import { ellipsis } from '@pocapan/shared/utils/TextUtil';
import MatchedTradingPhotoCardBottomSheet from '../bottomSheet/MatchedTradingPhotoCardBottomSheet';
import MatchedTradingPhotoCardBottomDrawer from '../drawer/MatchedTradingPhotoCardBottomDrawer';
import VerifiedIcon from '../icons/VerifiedIcon';

const imageBoxStyle = {
  width: '100%',
  height: '96%',
  padding: '12px 0px',
  background: 'var(--gray-surface, rgba(0, 0, 0, 0.04))',
  borderRadius: '20px'
};

const imageStyle = {
  width: '48px',
  height: '75px',
  borderRadius: '8px',
  objectFit: 'cover'
};

const profileStyle = {
  paddingLeft: '2px',
  fontWeight: 500,
  lineHeight: '16px',
  fontSize: '13px'
};

const requestedAtStyle = {
  color: '#999',
  fontSize: '11px',
  lineHeight: '13.2px',
  fontStyle: 'normal',
  fontWeight: '400',
  whiteSpace: 'pre'
};

const responseRateText = {
  color: `${colors.primary}`,
  fontSize: '11px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '13.2px'
};

export default function MatchedTargetTradingPhotoCard({ matchedTradingPhotoCard }) {
  const [isShowMatchedTradingPhotoCardBottomSheet, setIsShowMatchedTradingPhotoCardBottomSheet] =
    useState(false);

  return (
    matchedTradingPhotoCard && (
      <>
        <VStack
          key={matchedTradingPhotoCard.targetCard.tradingPhotoCardId}
          spacing={0}
          align={'flex-start'}
          minHeight={'140px'}
          onClick={() => setIsShowMatchedTradingPhotoCardBottomSheet(true)}
        >
          <Flex style={imageBoxStyle} justifyContent={'center'}>
            <Image
              style={imageStyle}
              src={matchedTradingPhotoCard.targetCard.photoCard.pictureUrl}
            />
          </Flex>
          <Flex direction={'row'} alignItems={'center'} paddingTop={'6px'} paddingBottom={'6px'}>
            {matchedTradingPhotoCard?.targetCard?.userProfile?.identified
              ? <VerifiedIcon width={'14px'} height={'14px'} className="fill-text-main-lv1" />
              : <ProfileFillIcon width={'14px'} height={'14px'} className="fill-text-main-lv1" />}
            <Text noOfLines={1} style={profileStyle} className="text-text-main-lv1">
              {ellipsis(matchedTradingPhotoCard.targetCard.userProfile.nickname, 6)}
            </Text>
          </Flex>
          <HStack spacing={0}>
            <Text style={requestedAtStyle}>{matchedTradingPhotoCard.targetCard.requestedAt}</Text>
            {!isEmpty(matchedTradingPhotoCard.targetCard.userProfile.chatStats?.responseText) && (
              <>
                <Text style={requestedAtStyle} px={'3px'}>
                  {'•'}
                </Text>
                <Text
                  style={responseRateText}
                >{`${matchedTradingPhotoCard.targetCard.userProfile.chatStats?.responseText}`}</Text>
              </>
            )}
          </HStack>
        </VStack>
        {/* <MatchedTradingPhotoCardBottomSheet
        matchedTradingPhotoCard={matchedTradingPhotoCard}
        isShowBottomSheet={isShowMatchedTradingPhotoCardBottomSheet}
        setIsShowBottomSheet={setIsShowMatchedTradingPhotoCardBottomSheet}
      /> */}
        <MatchedTradingPhotoCardBottomDrawer
          isOpen={isShowMatchedTradingPhotoCardBottomSheet}
          onClose={() => setIsShowMatchedTradingPhotoCardBottomSheet(false)}
          artistId={matchedTradingPhotoCard.artistId}
          matchedTradingPhotoCard={matchedTradingPhotoCard}
        />
      </>
    )
  );
}
